import { render, staticRenderFns } from "./supervision_list.vue?vue&type=template&id=ac47aff0&scoped=true&"
import script from "./supervision_list.vue?vue&type=script&lang=js&"
export * from "./supervision_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac47aff0",
  null
  
)

export default component.exports